import { useLocation } from "react-router";
import qs from "qs";

export const FACILITY = "facility";

export default () => {
  const location = useLocation();
  const facility = qs.parse(location.search.slice(1)).facility as string;
  if (facility) {
    sessionStorage.setItem(FACILITY, JSON.stringify(facility));
  }
};
